import { gql } from 'graphql-request';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useUserRemoveCoupon = () => {
  const { client } = graphqlConfig();

  const Mutation = useMutation(async ({ classId }: { classId?: number }) => client.request(
    gql`
    mutation UserRemoveCoupon($classId: Float!) {
      userRemoveCoupon(classId: $classId) {
        message
      }
    }
    `,
    {
      classId,
    }
  ));
  return Mutation;
};
